/**
 * Build-time feature flags surfaced to the SPA.
 *
 * Flags come from Vite env vars (VITE_*). Defaults match the most
 * conservative deployment posture — payments are off until NewebPay
 * onboarding completes, at which point we'll flip the env var rather
 * than re-merging code.
 */

const truthy = (v: string | undefined): boolean =>
  v === 'true' || v === '1' || v === 'yes';

export const paymentsEnabled: boolean = truthy(import.meta.env.VITE_PAYMENTS_ENABLED);
